import { ExpeirmentNodeProps } from 'business/models/CustomModels';
import React from 'react';
import TreeNode from './TreeNode';
import WithContextMenu from './WithContextMenu';

export default function ScreenNode(props: ExpeirmentNodeProps) {
  const node = props.data;
  const ContextifiedTreeNode = WithContextMenu(TreeNode);
  const Menu = () => <></>;

  const allProps = {
    ...props,
    link: `/screen/${node.extra.id}`,
    menu: Menu,
  };

  function onDragStart(e, id) {
    e.dataTransfer.setData('drag_type', 'SCREEN_NODE');
    e.dataTransfer.setData('id', id);
  }

  return (
    <ContextifiedTreeNode
      key={node.id}
      {...allProps}
      draggable={true}
      onDragStart={(e) => onDragStart(e, node.extra.id)}
    />
  );
}
